import { PlaybackOption, Playlist, PlaylistType } from '@repo/types'

import { ISpotifyPlaylist } from '@/store/integrations/spotify/types'

import { convertSongs } from './convertSongs'

export default function convertPlaylist(spotifyPlaylist: ISpotifyPlaylist): Playlist {
  const songs = spotifyPlaylist.tracks?.items?.length
    ? convertSongs(spotifyPlaylist.tracks.items.map(item => item.track))
    : []

  return {
    id: spotifyPlaylist.id,
    image: spotifyPlaylist.images?.[0],
    playbackOptions: [PlaybackOption.SPOTIFY],
    songs,
    title: spotifyPlaylist.name,
    type: PlaylistType.USER_SPOTIFY_LIBRARY
  }
}
